// language=SQL format=false
export const v2UpgradeStatements = [
    `ALTER TABLE no_delivery_reasons ADD COLUMN sort_order INTEGER;`,
    `ALTER TABLE payments ADD COLUMN foreign_returned_crates INTEGER NOT NULL DEFAULT 0;`,
];
